export const OPTIONS = { staleTime: Infinity }
